(function () {
  if (window.__SMARTSIZE_BOOTSTRAPPED__) return;
  window.__SMARTSIZE_BOOTSTRAPPED__ = true;

  const SMARTSIZE_ORIGIN = 'https://smartsize-front.decathlon.net';
  const SMARTSIZE_CLIENT_ID = '11dc60fd-3f22-4425-9c60-fd3f222425ac';
  const SMARTSIZE_LOCALE = 'fr-FR';
  const POLL_INTERVAL = 700;

  let currentHandle = null;
  let currentVariantId = null;
  let currentModelCode = null;
  let currentProduct = null;
  let intervalId = null;

  function getApps() {
    return Array.from(document.querySelectorAll('[data-smartsize-app]'));
  }

  function showFallbackForAll() {
    getApps().forEach((app) => {
      const embedWrap = app.querySelector('[data-smartsize-embed-wrap]');
      const fallbackWrap = app.querySelector('[data-smartsize-fallback-wrap]');
      if (embedWrap) embedWrap.hidden = true;
      if (fallbackWrap) fallbackWrap.hidden = false;
    });

    initLocalFallbacks();
  }

  function showIframeForAll(src) {
    getApps().forEach((app) => {
      const embedWrap = app.querySelector('[data-smartsize-embed-wrap]');
      const iframe = app.querySelector('[data-smartsize-iframe]');
      const fallbackWrap = app.querySelector('[data-smartsize-fallback-wrap]');

      if (iframe && iframe.src !== src) {
        iframe.src = src;
      }

      if (fallbackWrap) fallbackWrap.hidden = true;
      if (embedWrap) embedWrap.hidden = false;
    });
  }

  function patchHelpPanels() {
    document.querySelectorAll('popover-content[id*="-help-popover"]').forEach((popover) => {
      const overlay = popover.querySelector('.popover__overlay');
      const header = popover.querySelector('.popover__header');
      const content = popover.querySelector('.popover__content');

      if (overlay) overlay.style.pointerEvents = 'none';

      if (header) {
        header.style.position = 'relative';
        header.style.zIndex = '2';
      }

      if (content) {
        content.style.position = 'relative';
        content.style.zIndex = '2';
        content.style.overflow = 'auto';
        content.style.webkitOverflowScrolling = 'touch';
      }

      popover.querySelectorAll('iframe').forEach((frame) => {
        frame.style.pointerEvents = 'auto';
        frame.style.touchAction = 'auto';
        frame.style.position = 'relative';
        frame.style.zIndex = '2';
      });
    });
  }

  function safeUrl(raw) {
    try {
      return new URL(raw, window.location.origin);
    } catch (_) {
      return null;
    }
  }

  function extractHandleFromUrl(raw) {
    const url = safeUrl(raw);
    if (!url) return '';
    const match = url.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function extractVariantFromUrl(raw) {
    const url = safeUrl(raw);
    if (!url) return '';
    return url.searchParams.get('variant') || '';
  }

  function getPageParams() {
    const url = new URL(window.location.href);
    return {
      handle: url.searchParams.get('handle') || url.searchParams.get('product') || '',
      variantId: url.searchParams.get('variant') || ''
    };
  }

  function getCurrentVariantIdFromDom() {
    const selectors = [
      'form[action*="/cart/add"] [name="id"]',
      'product-form [name="id"]',
      '[data-product-form] [name="id"]',
      'input[name="id"]',
      'select[name="id"]'
    ];

    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (el && el.value) return String(el.value);
    }

    return '';
  }

  function getRootPath() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root;
      }
    } catch (_) {}
    return '/';
  }

  function buildProductJsUrl(handle) {
    const root = getRootPath().replace(/\/?$/, '/');
    return `${root}products/${encodeURIComponent(handle)}.js`;
  }

  function buildSmartsizeUrl(modelCode) {
    const url = new URL('https://smartsize-front.decathlon.net/');
    url.searchParams.set('modelCode', modelCode);
    url.searchParams.set('locale', SMARTSIZE_LOCALE);
    url.searchParams.set('clientId', SMARTSIZE_CLIENT_ID);
    return url.toString();
  }

  function resolveContext() {
    const pageParams = getPageParams();
    const referrer = document.referrer || '';

    const handle =
      pageParams.handle ||
      extractHandleFromUrl(window.location.href) ||
      extractHandleFromUrl(referrer);

    const variantId =
      pageParams.variantId ||
      getCurrentVariantIdFromDom() ||
      extractVariantFromUrl(window.location.href) ||
      extractVariantFromUrl(referrer);

    return { handle, variantId };
  }

  async function fetchProduct(handle) {
    const res = await fetch(buildProductJsUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error(`Impossible de charger le produit (${res.status})`);
    }

    return res.json();
  }

  function getOptionPosition(product, names) {
    const options = Array.isArray(product?.options) ? product.options : [];

    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const name = String(opt.name || '').trim().toLowerCase();
      if (names.includes(name)) return i + 1;
    }

    return null;
  }

  function findVariant(product, variantId) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    if (!variants.length) return null;

    if (variantId) {
      const found = variants.find(v => String(v.id) === String(variantId));
      if (found) return found;
    }

    return variants[0];
  }

  function extractModelCode(product, variant) {
    if (!variant) return '';

    const pos = getOptionPosition(product, [
      'model code',
      'code modèle',
      'code modele',
      'modelcode'
    ]);

    let value = '';
    if (pos === 1) value = variant.option1 || '';
    else if (pos === 2) value = variant.option2 || '';
    else if (pos === 3) value = variant.option3 || '';
    else value = variant.option3 || '';

    return String(value).trim();
  }

  function getCurrentVariant(product) {
    const currentId =
      getCurrentVariantIdFromDom() ||
      new URL(window.location.href).searchParams.get('variant') ||
      currentVariantId ||
      '';

    if (!product?.variants?.length) return null;

    return (
      product.variants.find(v => String(v.id) === String(currentId)) ||
      product.variants[0]
    );
  }

  function findRecommendedAvailableVariant(product, recommendedSize) {
    if (!product?.variants?.length || !recommendedSize) return null;

    const sizePos = getOptionPosition(product, ['size', 'taille']);
    const colorPos = getOptionPosition(product, ['color', 'couleur']);
    const current = getCurrentVariant(product);

    const wantedSize = String(recommendedSize).trim().toLowerCase();
    const currentColor = colorPos && current
      ? String(current[`option${colorPos}`] || '').trim().toLowerCase()
      : '';

    const matchesSize = (variant) => {
      if (!sizePos) return false;
      return String(variant[`option${sizePos}`] || '').trim().toLowerCase() === wantedSize;
    };

    const matchesColor = (variant) => {
      if (!colorPos || !currentColor) return true;
      return String(variant[`option${colorPos}`] || '').trim().toLowerCase() === currentColor;
    };

    let found = product.variants.find(v => matchesSize(v) && matchesColor(v) && v.available);

    if (!found) {
      found = product.variants.find(v => matchesSize(v) && v.available);
    }

    return found || null;
  }

  function getProductVariantsRoot() {
    return document.querySelector('product-variants') ||
           document.querySelector('.product-form') ||
           document.querySelector('form[action*="/cart/add"]') ||
           document;
  }

  function dispatchNativeEvents(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setSelectToText(select, text) {
    const normalized = String(text).trim().toLowerCase();

    const option = Array.from(select.options).find(opt => {
      const label = String(opt.textContent || opt.value || '').trim().toLowerCase();
      return label === normalized;
    });

    if (!option) return false;

    if (select.value !== option.value) {
      select.value = option.value;
      dispatchNativeEvents(select);
    }

    return true;
  }

  function clickOptionByText(root, text) {
    const normalized = String(text).trim().toLowerCase();

    for (const label of root.querySelectorAll('label[for]')) {
      const labelText = String(label.textContent || '').trim().toLowerCase();
      if (labelText !== normalized) continue;

      const input = document.getElementById(label.getAttribute('for'));
      if (input) {
        if (!input.checked) {
          input.checked = true;
          dispatchNativeEvents(input);
        } else {
          label.click();
        }
        return true;
      }
    }

    for (const el of root.querySelectorAll('button, [role="radio"], .swatch-element, .variant-input, .block-swatch')) {
      const txt = String(el.textContent || el.getAttribute('aria-label') || '').trim().toLowerCase();
      if (txt !== normalized) continue;
      el.click();
      return true;
    }

    return false;
  }

  function tryApplyVariantToUi(variant) {
    const root = getProductVariantsRoot();
    const sizePos = getOptionPosition(currentProduct, ['size', 'taille']);
    const colorPos = getOptionPosition(currentProduct, ['color', 'couleur']);

    const valuesToApply = [];

    if (colorPos && variant[`option${colorPos}`]) {
      valuesToApply.push(variant[`option${colorPos}`]);
    }

    if (sizePos && variant[`option${sizePos}`]) {
      valuesToApply.push(variant[`option${sizePos}`]);
    }

    let appliedSomething = false;

    for (const value of valuesToApply) {
      let applied = false;

      for (const select of root.querySelectorAll('select')) {
        if (setSelectToText(select, value)) {
          applied = true;
          appliedSomething = true;
          break;
        }
      }

      if (!applied && clickOptionByText(root, value)) {
        appliedSomething = true;
      }
    }

    for (const hiddenIdInput of document.querySelectorAll('form[action*="/cart/add"] [name="id"], input[name="id"]')) {
      hiddenIdInput.value = String(variant.id);
      dispatchNativeEvents(hiddenIdInput);
      appliedSomething = true;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    history.replaceState({}, '', url.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));

    return appliedSomething;
  }

  function isPanelVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    return !el.hidden && style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function forceClosePanel(panel) {
    if (!panel) return false;

    panel.hidden = true;
    panel.removeAttribute('open');
    panel.setAttribute('aria-hidden', 'true');

    const toggle = panel.id
      ? document.querySelector(`.product-meta__help[aria-controls="${panel.id}"]`)
      : null;

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    return true;
  }

  function closeActiveHelpPanel() {
    const panels = Array.from(document.querySelectorAll('drawer-content, popover-content'))
      .filter(panel => panel.id && panel.id.includes('-help-') && isPanelVisible(panel));

    for (const panel of panels) {
      const toggle = document.querySelector(`.product-meta__help[aria-controls="${panel.id}"]`);

      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.click();

        setTimeout(() => {
          if (isPanelVisible(panel)) {
            const closeBtn = panel.querySelector('[data-action="close"]');
            if (closeBtn) closeBtn.click();

            setTimeout(() => {
              if (isPanelVisible(panel)) {
                forceClosePanel(panel);
              }
            }, 120);
          }
        }, 80);

        return true;
      }

      const closeBtn = panel.querySelector('[data-action="close"]');
      if (closeBtn) {
        closeBtn.click();

        setTimeout(() => {
          if (isPanelVisible(panel)) {
            forceClosePanel(panel);
          }
        }, 120);

        return true;
      }

      forceClosePanel(panel);
      return true;
    }

    return false;
  }

  function selectRecommendedVariant(variant) {
    tryApplyVariantToUi(variant);

    setTimeout(() => {
      closeActiveHelpPanel();

      const selectedId = getCurrentVariantIdFromDom();
      if (String(selectedId) === String(variant.id)) {
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.location.assign(url.toString());
    }, 250);
  }

  function initLocalFallbackInstance(root) {
    if (!root || root.dataset.localFallbackInit === 'true') return;
    root.dataset.localFallbackInit = 'true';

    const uid = 'sg-' + Math.random().toString(36).slice(2, 8);

    root.querySelectorAll('[id]').forEach((el) => {
      const oldId = el.id;
      el.dataset.originalId = oldId;
      el.id = `${uid}-${oldId}`;
    });

    root.querySelectorAll('a[href^="#"]').forEach((a) => {
      const href = a.getAttribute('href');
      if (!href || href === '#') return;
      a.dataset.originalHref = href;
      const targetId = href.slice(1);
      a.setAttribute('href', `#${uid}-${targetId}`);
    });

    root.querySelectorAll('input[type="radio"][name="unit"]').forEach((input) => {
      input.name = `${uid}-unit`;
    });

    const radios = root.querySelector('.radios');
    if (radios) radios.classList.remove('hidden');

    const cmRadio = root.querySelector(`#${CSS.escape(uid + '-cm')}`);
    const inRadio = root.querySelector(`#${CSS.escape(uid + '-in')}`);

    function updateUnits(unit) {
      root.querySelectorAll('.centimeters').forEach((el) => {
        el.classList.toggle('hidden', unit !== 'cm');
      });

      root.querySelectorAll('.inches').forEach((el) => {
        el.classList.toggle('hidden', unit !== 'in');
      });
    }

    if (cmRadio && inRadio) {
      if (!cmRadio.checked && !inRadio.checked) {
        cmRadio.checked = true;
      }

      updateUnits(cmRadio.checked ? 'cm' : 'in');

      cmRadio.addEventListener('change', () => updateUnits('cm'));
      inRadio.addEventListener('change', () => updateUnits('in'));
    }

    const isScrollable = (el) => {
      if (!el) return false;
      const s = getComputedStyle(el);
      return /(auto|scroll|overlay)/.test(s.overflowY) && el.scrollHeight > el.clientHeight;
    };

    const closestScrollable = (el) => {
      for (let p = el; p; p = p.parentElement) {
        if (isScrollable(p)) return p;
      }
      return null;
    };

    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a || !root.contains(a)) return;

      const href = a.getAttribute('href');
      if (!href || href === '#') return;

      const target = root.querySelector(`#${CSS.escape(href.slice(1))}`);
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      const scroller =
        closestScrollable(target) ||
        closestScrollable(root.closest('.popover__content')) ||
        closestScrollable(root.closest('.drawer__content')) ||
        document.scrollingElement;

      const popoverHeader =
        root.closest('popover-content')?.querySelector('.popover__header') || null;

      const drawerHeader =
        root.closest('drawer-content')?.querySelector('.drawer__header') || null;

      const header = popoverHeader || drawerHeader;
      const offset = header ? Math.ceil(header.getBoundingClientRect().height) + 8 : 8;

      if (
        scroller === document.scrollingElement ||
        scroller === document.documentElement ||
        scroller === document.body
      ) {
        const top = window.scrollY + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        return;
      }

      const tr = target.getBoundingClientRect();
      const cr = scroller.getBoundingClientRect();
      const top = scroller.scrollTop + (tr.top - cr.top) - offset;

      scroller.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }, true);
  }

  function initLocalFallbacks() {
    getApps().forEach((app) => {
      const root = app.querySelector('[data-smartsize-fallback-local]');
      initLocalFallbackInstance(root);
    });
  }

  window.addEventListener('message', (event) => {
    if (event.origin !== SMARTSIZE_ORIGIN) return;

    let payload = event.data;
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (_) {
        return;
      }
    }

    if (!payload || typeof payload !== 'object') return;

    if (payload.event === 'ERROR') {
      showFallbackForAll();
      patchHelpPanels();
      return;
    }

    if (payload.event === 'SIZE_SELECTED' && payload.data?.status === 'ok') {
      const recommendedSize = payload.data?.size;
      if (!recommendedSize || !currentProduct) return;

      const targetVariant = findRecommendedAvailableVariant(currentProduct, recommendedSize);
      if (!targetVariant) return;

      selectRecommendedVariant(targetVariant);
    }
  });

  async function sync() {
    try {
      const { handle, variantId } = resolveContext();

      if (!handle) {
        showFallbackForAll();
        patchHelpPanels();
        return;
      }

      if (!currentProduct || handle !== currentHandle) {
        currentProduct = await fetchProduct(handle);
        currentHandle = handle;
      }

      const variant = findVariant(currentProduct, variantId);
      const liveVariantId = variant ? String(variant.id) : '';
      const modelCode = extractModelCode(currentProduct, variant);

      if (!modelCode) {
        showFallbackForAll();
        patchHelpPanels();
        return;
      }

      if (
        currentHandle === handle &&
        currentVariantId === liveVariantId &&
        currentModelCode === modelCode
      ) {
        patchHelpPanels();
        initLocalFallbacks();
        return;
      }

      currentVariantId = liveVariantId;
      currentModelCode = modelCode;

      showIframeForAll(buildSmartsizeUrl(modelCode));
      patchHelpPanels();
      initLocalFallbacks();
    } catch (_) {
      showFallbackForAll();
      patchHelpPanels();
      initLocalFallbacks();
    }
  }

  document.addEventListener('change', sync, true);
  document.addEventListener('input', sync, true);
  document.addEventListener('click', patchHelpPanels, true);
  document.addEventListener('touchstart', patchHelpPanels, true);
  document.addEventListener('pointerdown', patchHelpPanels, true);
  window.addEventListener('popstate', sync);
  window.addEventListener('pageshow', sync);

  sync();
  patchHelpPanels();
  initLocalFallbacks();

  intervalId = setInterval(() => {
    sync();
    patchHelpPanels();
    initLocalFallbacks();
  }, POLL_INTERVAL);

  window.addEventListener('pagehide', function () {
    if (intervalId) clearInterval(intervalId);
  });
})();